// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomErrorPage_container__yEVau","title":"CustomErrorPage_title__t0In5","message":"CustomErrorPage_message__juEGh"};